import auth from '@/router/auth'
import CategoryCourseIndex from '@/components/category-online/Index'
import CategoryCourseCreate from '@/components/category-online/Create'
import CategoryCourseUpdate from '@/components/category-online/Update'
import CategoryCourseShow from '@/components/category-online/Show'

export default [
  {
    path: '/category-online',
    name: 'category-online-index',
    component: CategoryCourseIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/category-online/create',
    name: 'category-online-create',
    component: CategoryCourseCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/category-online/update/:id',
    name: 'category-online-update',
    component: CategoryCourseUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/category-online/show/:id',
    name: 'category-online-show',
    component: CategoryCourseShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/category-online/router.js